
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import MenuComboActionTile from "./menu-combo-action-tile.vue";
import MenuComboItemRowWithSwitch from "./menu-combo-item-row-with-switch.vue";
export default {
  components: {
    MenuComboItemRowWithSwitch,
    MenuComboActionTile
  },
  data() {
    return {
      panel: ""
    };
  },
  mounted() {
    this.getCombosList();
  },
  computed: {
    ...mapState("menu", ["combosList"])
  },
  methods: {
    ...mapActions("menu", ["getCombosList"]),
    handleHeaderClick(combo) {
      if (!this.$vuetify.breakpoint.mdAndUp) {
        this.$emit("open-expansion-content", combo);
      }
    }
  }
};
